import React, { useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import { getPasswordValidatorsByPasswordStrength, isConfirmationFieldValidator, } from '../../../model/passwordValidator';
import useT from '../utils/Translations/useT';
const FormPasswordValidation = ({ className = '', password = '', passwordConfirmation = '', input, passwordStrength, }) => {
    const t = useT();
    const [validationResults, setValidationResults] = useState([]);
    const update = useCallback(props => {
        const { input: { onChange }, password, passwordConfirmation, passwordStrength, } = props;
        const validators = getPasswordValidatorsByPasswordStrength(passwordStrength, t);
        const { passwordValidationResults, confirmationValidationResults, totalValidationResults, } = applyValidators(validators, password, passwordConfirmation);
        if (!_.isEqual(validationResults, totalValidationResults)) {
            setValidationResults(totalValidationResults);
            const password = getValidationResultsErrors(passwordValidationResults);
            const confirmation = getValidationResultsErrors(confirmationValidationResults);
            onChange({
                password,
                confirmation,
            });
        }
    }, [t, validationResults, setValidationResults]);
    useEffect(() => {
        update({ input, password, passwordConfirmation, passwordStrength });
    }, [update, input, password, passwordConfirmation, passwordStrength]);
    return (<ul className={classnames('list-unstyled', className)}>
      {validationResults.map(({ isValid, label }) => (<li key={isValid + label}>
          <span>
            <i className={isValid
        ? 'icon-checkmark3 text-success'
        : 'icon-cross2 text-danger'}/>
            {` ${label}`}
          </span>
        </li>))}
    </ul>);
};
export function applyValidators(validators, password, passwordConfirmation) {
    const passwordValidationResults = [];
    const confirmationValidationResults = [];
    validators.map(passwordValidator => {
        const confirmationField = isConfirmationFieldValidator(passwordValidator);
        const errorMessage = passwordValidator.validator(password, passwordConfirmation);
        const validationResultsArray = confirmationField
            ? confirmationValidationResults
            : passwordValidationResults;
        validationResultsArray.push({
            label: passwordValidator.label,
            isValid: !errorMessage,
            errorMessage,
            confirmationField,
        });
    });
    return {
        passwordValidationResults,
        confirmationValidationResults,
        totalValidationResults: [
            ...passwordValidationResults,
            ...confirmationValidationResults,
        ],
    };
}
export function getValidationResultsErrors(validationResults) {
    return validationResults
        .filter(({ isValid }) => !isValid)
        .map(({ errorMessage }) => errorMessage);
}
export default FormPasswordValidation;
